module.exports = __webpack_public_path__ + "img/IMG_5887.4e0bed77.jpg";